module.exports = veStoreMfeConfig;